<template>
  <div class="container-fluid px-4">
    <template v-if="loading">
      <app-loading></app-loading>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-12">
          <div class="row align-items-center">
            <div class="col-8">
              <h2 class="h2 e-text-red">Summary of Managing Vessels</h2>
            </div>
            <div class="col-2 text-right pr-0" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
<!--              <button id="downloadManagingVesselSummary" class="e-btn e-btn-blue-gray force-white-all btn-block"-->
<!--                      @click="downloadManagingVesselSummary()"-->
<!--              >-->
<!--                <font-awesome-icon class="mr-1" icon="download"/>-->
<!--                Download Managing Vessels-->
<!--              </button>-->
            </div>
            <div class="col-2 text-right" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
              <button id="downloadAllVesselSummary" class="e-btn e-btn-blue-gray force-white-all btn-block"
                      @click="downloadAllVesselSummary"
              >
                <font-awesome-icon class="mr-1" icon="download"/>
                Download Vessel Report Summary
              </button>
            </div>
          </div>

          <div class="row col-12 p-0 m-0">
            <table class="table text-center table-sm small e-tbl">
              <thead class="bg-white">
              <tr>
                <th>ISM Management Company</th>

                <th class="text-uppercase" v-for="data in vesselManagement.vesselCountOnEachFleet" :colspan="data?.management_offices?.reduce((total, office) => total + office?.fleets.length, 0)">{{ data.name }}</th>
              </tr>

              <tr>
                <th>Management Branch Office</th>
                <template v-for="data in vesselManagement.vesselCountOnEachFleet">
                  <th class="text-uppercase align-middle" v-for="office in data.management_offices" :colspan="office.fleets.length">
                    {{ office.name }}
                  </th>
                </template>
              </tr>

              <tr>
                <th>Fleet</th>
                <template v-for="data in vesselManagement.vesselCountOnEachFleet">
                  <template v-for="office in data.management_offices">
                    <th class="text-uppercase align-middle" v-for="fleet in office.fleets">
                      {{ fleet.name }}
                    </th>
                  </template>
                </template>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th class="custom">Number Of vessel</th>
                <template v-for="data in vesselManagement.vesselCountOnEachFleet">
                  <template v-for="office in data.management_offices">
                    <td class="text-uppercase align-middle" v-for="fleet in office.fleets">
                      <a href="#" @click="getVesselListByParam(data.id, office.id, fleet.id)"> {{ fleet.vessel_count }} </a>
                    </td>
                  </template>
                </template>
              </tr>
              <tr>
                <th class="custom">Sub Total By branch office</th>
                <template v-for="data in vesselManagement.vesselCountOnEachFleet">
                  <template v-for="office in data.management_offices">
                    <td :colspan="office.fleets.length" class="align-middle">
                      <a href="#" @click="getVesselListByParam(data.id, office.id)">
                        {{ office.fleets.reduce((total, fleet) => total + fleet.vessel_count, 0)}}
                      </a>
                    </td>
                  </template>
                </template>
              </tr>

              <tr>
                <th class="custom">Sub Total By DOC</th>
                <template v-for="data in vesselManagement.vesselCountOnEachFleet">
                  <td :colspan="data?.management_offices?.reduce((total, office) => total + office?.fleets.length, 0)" class="align-middle">
                    <a href="#" @click="getVesselListByParam(data.id)">
                      {{ data?.management_offices?.reduce((management_total, office) => management_total + office?.fleets.reduce((office_total, fleet) => office_total + fleet.vessel_count, 0), 0) }}
                    </a>
                  </td>
                </template>
              </tr>

              <tr>
                <th class="custom">Total</th>
                <td class="align-middle" :colspan="vesselManagement.vesselCountOnEachFleet.reduce((company_total, company) => company_total + company.management_offices.reduce((office_total, office) => office_total + office.fleets.length, 0), 0)">
                  <a href="#" @click="getVesselListByParam()">
                    {{ vesselManagement.vesselCountOnEachFleet.reduce(
                    (total, company) => total + company.management_offices?.reduce(
                      (office_total, office) => office_total + office.fleets.reduce(
                        (fleet_total, fleet) => fleet_total + fleet.vessel_count,
                        0),
                      0),
                    0) }}
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <ul class="nav nav-tabs" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button @click="summaryModuleTab = 'graphs'" class="main-tabs nav-link active h6 text-uppercase font-weight-bold" id="pills-graphs-tab" data-toggle="pill" data-target="#pills-graphs" type="button" role="tab" aria-controls="pills-graphs" aria-selected="true">
                VESSEL
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button @click="summaryModuleTab = 'crew_dashboard'" class="main-tabs nav-link h6 text-uppercase font-weight-bold" id="pills-dashboard-tab" data-toggle="pill" data-target="#pills-dashboard" type="button" role="tab" aria-controls="pills-dashboard" aria-selected="false">
                CREW
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button @click="summaryModuleTab = 'machinery-graphs'" class="main-tabs nav-link h6 text-uppercase font-weight-bold" id="pills-machinery-graphs-tab" data-toggle="pill" data-target="#pills-machinery-graphs" type="button" role="tab" aria-controls="pills-machinery-graphs" aria-selected="false">
                MACHINERY
              </button>
            </li>
          </ul>
          <div class="tab-content mt-3" id="pills-tabContent">
            <!--GRAPHS TAB-->
            <div class="tab-pane fade show active" id="pills-graphs" role="tabpanel" aria-labelledby="pills-graphs-tab">
              <div class="row">
                <!-- By Flag -->
                <div class="col-md-6">
                  <div class="card shadow-sm rounded mb-3 mt-3">
                    <div class="card-body h-100">
                      <div class="row">
                        <div class="col-8">
                          <div class="text-uppercase font-weight-bold h6">By Flag</div>
                        </div>
                        <div class="col-4" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                          <button class="ml-2 float-right e-btn e-btn-blue-gray force-white-all"
                                  @click="downloadIndividualGraph('vessel-pie-flag-individual')"
                          >
                            <font-awesome-icon class="mr-1" icon="download"/> Download Graph
                          </button>
                        </div>
                      </div>
                      <hr>
                      <VesselRecordFlagPieChart
                        :key="$route.params.report_type + '_' + vesselRecordByFlagSeries.length"
                        :series="vesselRecordByFlagSeries"
                        :labels="vesselRecordByFlagLabels.map(str => str.toUpperCase())"
                      />
                    </div>
                  </div>
                </div>

                <!-- By Age -->
                <div class="col-md-6">
                  <div class="card shadow-sm rounded mb-3 mt-3">
                    <div class="card-body h-100">
                      <div class="row">
                        <div class="col-8">
                          <div class="text-uppercase font-weight-bold h6">By Age</div>
                        </div>
                        <div class="col-4" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                          <button class="ml-2 float-right e-btn e-btn-blue-gray force-white-all"
                                  @click="downloadIndividualGraph('vessel-pie-age-individual')"
                          >
                            <font-awesome-icon class="mr-1" icon="download"/> Download Graph
                          </button>
                        </div>
                      </div>
                      <hr>
                      <VesselRecordAgePieChart
                        :key="$route.params.report_type + '_' + vesselRecordByAgeSeries.length"
                        :series="vesselRecordByAgeSeries"
                        :labels="vesselRecordByAgeLabels.map(str => str.toUpperCase())"
                      />
                    </div>
                  </div>
                </div>

                <!-- By Ship Builder -->
                <div class="col-md-12">
                  <VesselShipBuilderGraph></VesselShipBuilderGraph>
                </div>

                <!-- By Ship Type -->
                <div class="col-md-6">
                  <div class="card shadow-sm rounded mb-3 mt-3">
                    <div class="card-body h-100">
                      <div class="row">
                        <div class="col-8">
                          <div class="text-uppercase font-weight-bold h6">By Ship Type</div>
                        </div>
                        <div class="col-4" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                          <button class="ml-2 float-right e-btn e-btn-blue-gray force-white-all"
                                  @click="downloadIndividualGraph('vessel-pie-ship-type-individual')"
                          >
                            <font-awesome-icon class="mr-1" icon="download"/> Download Graph
                          </button>
                        </div>
                      </div>
                      <hr>
                      <VesselRecordShipTypePieChart
                        :key="$route.params.report_type + '_' + vesselRecordByShipTypeSeries.length"
                        :series="vesselRecordByShipTypeSeries"
                        :labels="vesselRecordByShipTypeLabels.map(str => str.toUpperCase())"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--END GRAPHS TAB-->
            <!--MANNING TAB-->
            <div class="tab-pane fade" id="pills-dashboard" role="tabpanel" aria-labelledby="pills-dashboard-tab">
              <!--SUMMARY PER MANNING-->
              <div class="row">
                <div class="col-12">
                  <div class="card shadow-sm">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="h6 font-weight-bold text-uppercase mb-0">Summary</span>

                        <div class="float-right text-right dropdown dropright" v-if="true && hideDownloadButtonCrewSummary">
                          <button id="committeeReport" aria-expanded="false" aria-haspopup="true" :disabled="false" :class="['e-btn e-btn-primary force-white-all',{'e-btn-blue-gray-disabled': false}]"
                                  data-toggle="dropdown"
                          >
                            <font-awesome-icon class="mr-1" icon="download"/>
                            Download
                          </button>
                          <div aria-labelledby="committeeReport" class="dropdown-menu">
                            <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadCrewInfoSummary('excel')" type="button">
                              <font-awesome-icon icon="file-excel"/>
                              Excel
                            </button>
                            <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadCrewInfoSummary('pdf')" type="button">
                              <font-awesome-icon icon="file-pdf"/>
                              PDF
                            </button>
                          </div>
                        </div>
                      </div>
                      <hr style="border-top: 2px solid #DBDBDB">
                      <div class="row">
                        <div class="col-12">
<!--                          <span class="h6 font-weight-bold text-uppercase">Summary Per Manning</span>-->

                          <ul class="nav nav-tabs" id="pills-tab" role="tablist">
                            <li class="nav-item" role="presentation">
                              <button class="main-tabs nav-link active text-uppercase font-weight-bold" @click="crewSummaryModule = 'per_nationality'" data-toggle="pill" data-target="#pills-summary-per-nationality-tab-container" type="button" role="tab" aria-controls="pills-dashboard" aria-selected="true">
                                Per Nationality
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button class="main-tabs nav-link text-uppercase font-weight-bold" @click="crewSummaryModule = 'per_manning'" data-toggle="pill" data-target="#pills-summary-per-manning-tab-container" type="button" role="tab" aria-controls="pills-graphs" aria-selected="false">
                                Per Manning
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button class="main-tabs nav-link text-uppercase font-weight-bold" @click="crewSummaryModule = 'per_rank'" data-toggle="pill" data-target="#pills-summary-per-nationality-tab-container" type="button" role="tab" aria-controls="pills-dashboard" aria-selected="false">
                                Per Rank
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button class="main-tabs nav-link text-uppercase font-weight-bold" @click="crewSummaryModule = 'per_manning_assignment'" data-toggle="pill" data-target="#pills-summary-per-manning-assignment-tab-container" type="button" role="tab" aria-controls="pills-dashboard" aria-selected="false">
                                Per Manning Assignment
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button class="main-tabs nav-link text-uppercase font-weight-bold" @click="crewSummaryModule = 'per_vessel'" data-toggle="pill" data-target="#pills-summary-per-vessel-tab-container" type="button" role="tab" aria-controls="pills-dashboard" aria-selected="false">
                                Per Vessel
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button class="main-tabs nav-link text-uppercase font-weight-bold" @click="crewSummaryModule = 'per_crew_age'" data-toggle="pill" data-target="#pills-summary-per-vessel-tab-container" type="button" role="tab" aria-controls="pills-dashboard" aria-selected="false">
                                Per Crew Age
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="tab-pane fade show active" v-if="crewSummaryModule === 'per_manning'" role="tabpanel" aria-labelledby="pills-graphs-tab">
                            <div class="table-responsive">
                              <table class="table table-bordered">
                                <tr>
                                  <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">
                                    Manning Company
                                  </th>
                                  <td class="text-center text-uppercase font-weight-bold" style="background-color: #e1e1e1; border: 1px solid #c3c3c3" v-for="(data, index) in totalCrew" :key="index">{{ data.alias }}</td>
                                </tr>
                                <tr>
                                  <th class="text-right text-uppercase" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">Onboard Crew</th>
                                  <td class="text-center" v-for="(data, index) in totalCrew" :key="index">{{data.totalOnboardCrewCount}}</td>
                                </tr>
                                <tr style="border-top: 2px solid #d1d1d1">
                                  <th class="text-right text-uppercase" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">Total Crew</th>
                                  <td class="text-center font-weight-bold" v-for="(data, index) in totalCrew" :key="index">{{data.totalCrewCount}}</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                          <!--SUMMARY PER MANNING RANK-->
                          <div class="row mt-3 mb-3" v-else-if="crewSummaryModule === 'per_rank'">
                            <div class="col-12">
                              <div class="card shadow-sm">
                                <div class="card-body">
                                  <div class="row">
                                    <div class="col-6 my-auto">
                                      <span class="h6 font-weight-bold text-uppercase text-danger">{{this.cardRankTitle}}</span>
                                    </div>
                                    <div class="col-6 my-auto">
                                      <ul class="nav nav-pills float-right" id="pills-tab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                          <button style="border: 2px solid gray; color: #d3313c; border-radius: 10px 0px 0px 10px !important;" class="nav-link active text-uppercase font-weight-bold btn-sm rounded-0" id="pills-onboard-tab" data-toggle="pill" data-target="#pills-onboard" type="button" role="tab" aria-controls="pills-onboard" @click="changeCardRankTitle('Onboard')" aria-selected="true">Onboard</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                          <button style="border: 2px solid gray; color: #d3313c; border-radius: 0px 10px 10px 0px !important;" class="nav-link text-uppercase font-weight-bold btn-sm rounded-0" id="pills-totalcrew-tab" data-toggle="pill" data-target="#pills-totalcrew" type="button" role="tab" aria-controls="pills-totalcrew" @click="changeCardRankTitle('TotalCrew')" aria-selected="false">Total Crew</button>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <hr style="border-top: 2px solid #DBDBDB;">
                                  <div class="tab-content" id="pills-tabContent">
                                    <div class="tab-pane fade show active" id="pills-onboard" role="tabpanel" aria-labelledby="pills-onboard-tab">
                                      <div>
                                        <ul class="nav nav-tabs" id="pills-tab" role="tablist">
                                          <li class="nav-item" role="presentation">
                                            <button class="main-tabs nav-link text-uppercase font-weight-bold" :class="{'active' : summaryOnBoardActiveTab === 'details'}" id="pills-onboard-details-tab" data-toggle="pill" data-target="#pills-onboard-details" type="button" role="tab" aria-controls="pills-onboard-details" aria-selected="true" @click="summaryOnBoardActiveTab = 'details'">Details</button>
                                          </li>
                                          <li class="nav-item" role="presentation">
                                            <button class="main-tabs nav-link text-uppercase font-weight-bold" :class="{'active' : summaryOnBoardActiveTab === 'graph'}" id="pills-onboard-graph-tab" data-toggle="pill" data-target="#pills-onboard-graph" type="button" role="tab" aria-controls="pills-onboard-graph" aria-selected="false" @click="summaryOnBoardActiveTab = 'graph'">Pie Graph Per Rank</button>
                                          </li>
                                        </ul>
                                      </div>
                                      <div v-if="summaryOnBoardActiveTab === 'details'" class="tab-pane show active" role="tabpanel" aria-labelledby="pills-onboard-details-tab">
                                        <div class="row">
                                          <div class="col-12">
                                            <div class="table-responsive">
                                              <table class="table table-bordered mr-1">
                                                <thead>
                                                <tr>
                                                  <th class="text-center text-uppercase align-middle" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">
                                                    Ranks
                                                  </th>
                                                  <th v-for="(data, index) in totalCrew" :key="index" class="text-center text-uppercase align-middle" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">{{ data.alias }}</th>
                                                  <th class="text-center text-uppercase" style="background-color: #c9c9c9; border-bottom: 3px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 5px solid #676767; min-width: 105px;">Total Crew (Per Rank)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(data, indexRank) in totalCrew[0]?.totalCrewPerRank" :key="indexRank">
                                                  <th class="text-right text-uppercase" style="background-color: #e1e1e1; border: 1px solid #c3c3c3; max-width: 500px;">{{data.name}}</th>
                                                  <template v-for="(rank, index) in totalCrew">
                                                    <template v-for="(item, index) in rank.totalOnboardCrewPerRank">
                                                      <template v-if="item.total != 0">
                                                        <td v-if="item.name == data.name" class="text-center align-middle text-primary font-weight-bold" @click="getManningCrewFromCms(item, rank, 'onboard')" style="cursor: pointer" title="Click to view crew list">
                                                          {{item.total}}
                                                        </td>
                                                      </template>
                                                      <template v-else>
                                                        <td v-if="item.name == data.name" class="text-center align-middle">
                                                          {{item.total}}
                                                        </td>
                                                      </template>
                                                    </template>
                                                  </template>
                                                  <td class="text-center align-middle" style="background-color: #c9c9c9; border-bottom: 1px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 5px solid #676767;">{{ getTotalSumOfOnboardRank(data.name) }}</td>
                                                </tr>
                                                <tr style="border-top: 5px solid #676767">
                                                  <th class="text-right text-uppercase" style="background-color: #c9c9c9; border: 1px solid #b3b3b3; max-width: 500px;">Total Crew</th>
                                                  <template v-for="(data, indexRank) in totalCrew">
                                                    <td class="text-center font-weight-bold align-middle" style="background-color: #c9c9c9; border: 1px solid #b3b3b3;">{{ data.totalOnboardCrewCount }}</td>
                                                  </template>
                                                  <td style="background-color: #c9c9c9; border-bottom: 1px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 1px solid #b3b3b3;" class="text-center font-weight-bold align-middle">{{ getTotalOfAllOnboardRanks() }}</td>
                                                </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div v-else class="tab-pane show active" role="tabpanel" aria-labelledby="pills-onboard-graph-tab">
                                        <div class="row mt-1">
                                          <div class="col-12" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                                            <button id="downloadSummaryOnBoardCrewChart" class="cursor-pointer float-right ml-2 e-btn e-btn-blue-gray force-white-all"
                                                    @click="$refs['summary-on-board-crew-pie'].getGraphImage()"
                                            >
                                              <font-awesome-icon class="mr-1" icon="download"/>
                                              Download Graph
                                            </button>
                                          </div>
                                        </div>

                                        <SummaryOnBoardCrewPieChart
                                          :series="onBoardCrewRankSeries"
                                          :labels="onBoardCrewRankLabels"
                                          :full-data="totalCrew"
                                          @showDataFromCms="getManningCrewFromCms"
                                          ref="summary-on-board-crew-pie"
                                        />
                                      </div>
                                    </div>
                                    <div class="tab-pane fade" id="pills-totalcrew" role="tabpanel" aria-labelledby="pills-totalcrew-tab">
                                      <div>
                                        <ul class="nav nav-tabs" id="pills-tab" role="tablist">
                                          <li class="nav-item" role="presentation">
                                            <button class="main-tabs nav-link text-uppercase font-weight-bold" :class="{'active' : summaryTotalCrewActiveTab === 'details'}" id="pills-total-crew-details-tab" data-toggle="pill" data-target="#pills-total-crew-details" type="button" role="tab" aria-controls="pills-total-crew-details" aria-selected="true" @click="summaryTotalCrewActiveTab = 'details'">Details</button>
                                          </li>
                                          <li class="nav-item" role="presentation">
                                            <button class="main-tabs nav-link text-uppercase font-weight-bold" :class="{'active' : summaryTotalCrewActiveTab === 'graph'}" id="pills-total-crew-graph-tab" data-toggle="pill" data-target="#pills-total-crew-graph" type="button" role="tab" aria-controls="pills-total-crew-graph" aria-selected="false" @click="summaryTotalCrewActiveTab = 'graph'">Bar Graph</button>
                                          </li>
                                        </ul>
                                      </div>
                                      <div v-if="summaryTotalCrewActiveTab === 'details'" class="tab-pane show active" role="tabpanel" aria-labelledby="pills-total-crew-details-tab">
                                        <div class="row">
                                          <div class="col-12">
                                            <div class="table-responsive">
                                              <table class="table table-bordered mr-1">
                                                <thead>
                                                <tr>
                                                  <th class="text-center align-middle text-uppercase" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">
                                                    Ranks
                                                  </th>
                                                  <th v-for="(data, index) in totalCrew" :key="index" class="text-center align-middle text-uppercase" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">{{ data.alias }}</th>
                                                  <th class="text-center align-middle text-uppercase" style="background-color: #c9c9c9; border-bottom: 3px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 5px solid #676767; min-width: 150px;">Total Crew (Per Rank)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(data, indexRank) in totalCrew[0]?.totalCrewPerRank" :key="indexRank">
                                                  <th class="text-right text-uppercase" style="background-color: #e1e1e1; border: 1px solid #c3c3c3; max-width: 500px;">{{data.name}}</th>
                                                  <template v-for="(rank, index) in totalCrew">
                                                    <template v-for="(item, index) in rank.totalCrewPerRank">
                                                      <template v-if="item.total != 0">
                                                        <td v-if="item.name == data.name" class="text-center align-middle text-primary font-weight-bold" @click="getManningCrewFromCms(item, rank, '')" style="cursor: pointer" title="Click to view crew list">
                                                          {{item.total}}
                                                        </td>
                                                      </template>
                                                      <template v-else>
                                                        <td v-if="item.name == data.name" class="text-center align-middle">
                                                          {{item.total}}
                                                        </td>
                                                      </template>
                                                    </template>
                                                  </template>
                                                  <td class="text-center align-middle" style="background-color: #c9c9c9; border-bottom: 1px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 5px solid #676767;">{{ getTotalSumRank(data.name) }}</td>
                                                </tr>
                                                <tr style="border-top: 5px solid #676767">
                                                  <th class="text-right text-uppercase" style="background-color: #c9c9c9; border: 1px solid #b3b3b3; max-width: 500px;">Total Crew</th>
                                                  <template v-for="(data, indexRank) in totalCrew">
                                                    <td class="text-center align-middle font-weight-bold" style="background-color: #c9c9c9; border: 1px solid #b3b3b3;">{{ data.totalCrewCount }}</td>
                                                  </template>
                                                  <td style="background-color: #c9c9c9; border-bottom: 1px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 1px solid #b3b3b3;" class="text-center align-middle font-weight-bold">{{ getTotalOfAllRanks() }}</td>
                                                </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div v-else class="tab-pane show active" role="tabpanel" aria-labelledby="pills-total-crew-graph-tab">
                                        <div class="row mt-1">
                                          <div class="col-12" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                                            <button id="downloadSummaryOnBoardCrewChart" class="cursor-pointer float-right ml-2 e-btn e-btn-blue-gray force-white-all"
                                                    @click="$refs['summary-total-crew-bar'].getGraphImage()"
                                            >
                                              <font-awesome-icon class="mr-1" icon="download"/>
                                              Download Graph
                                            </button>
                                          </div>
                                        </div>
                                        <summary-total-crew-bar-graph
                                          :full-data="totalCrew"
                                          @showDataFromCms="getManningCrewFromCms"
                                          ref="summary-total-crew-bar"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="tab-pane fade show active" v-else-if="crewSummaryModule === 'per_nationality'" role="tabpanel" aria-labelledby="pills-graphs-tab">
                            <div class="table-responsive">
                              <template v-if="onboardCrewNationalityStats.length === 0">
                                <app-loading :message="'Fetching CMS data, Please wait...'"></app-loading>
                              </template>
                              <template v-else>
                                <div class="table-responsive">
                                  <table class="table table-bordered">
                                    <tr>
                                      <th rowspan="2" style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">
                                        Per Nationality
                                      </th>
                                      <th v-for="(data, index) in onboardCrewNationalityStats" :key="'nationality-' + index" colspan="3" class="text-center text-uppercase font-weight-bold" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">
                                        {{ data.nationality }}
                                      </th>
                                    </tr>
                                    <tr>
                                      <template v-for="(data, index) in onboardCrewNationalityStats">
                                        <th :key="'total-header-' + index" class="text-center">
                                          Total
                                        </th>
                                        <th :key="'male-header-' + index" class="text-center">
                                          Male
                                        </th>
                                        <th :key="'female-header-' + index" class="text-center">
                                          Female
                                        </th>
                                      </template>
                                    </tr>
                                    <tr>
                                      <th class="text-center text-uppercase" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">
                                        Onboard Crew
                                      </th>
                                      <template v-for="(data, index) in onboardCrewNationalityStats">
                                        <td :key="'onboard-total-' + index" class="text-center">
                                          {{ data.onboard_crew_count }}
                                        </td>
                                        <td :key="'onboard-male-' + index" class="text-center" style="color: #0000f6;">
                                          {{ data.male_onboard_crew_count }}
                                        </td>
                                        <td :key="'onboard-female-' + index" class="text-center" style="color: #f50195;">
                                          {{ data.female_onboard_crew_count }}
                                        </td>
                                      </template>
                                    </tr>
                                    <tr style="border-top: 2px solid #d1d1d1">
                                      <th class="text-center text-uppercase" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">
                                        Total Crew
                                      </th>
                                      <template v-for="(data, index) in onboardCrewNationalityStats">
                                        <td :key="'crew-total-' + index" class="text-center font-weight-bold">
                                          {{ data.crew_count }}
                                        </td>
                                        <td :key="'crew-male-' + index" class="text-center font-weight-bold" style="color: #0000f6;">
                                          {{ data.male_crews }}
                                        </td>
                                        <td :key="'crew-female-' + index" class="text-center font-weight-bold" style="color: #f50195;">
                                          {{ data.female_crews }}
                                        </td>
                                      </template>
                                    </tr>
                                  </table>
                                </div>
                                <summary-per-nationality-bar-graph :full-data="onboardCrewNationalityStats"/>
                              </template>

                            </div>
                          </div>

                          <div class="tab-pane fade show active" v-else-if="crewSummaryModule === 'per_vessel'" id="pills-summary-per-vessel-tab-container" role="tabpanel" aria-labelledby="pills-graphs-tab">
                            <div class="table-responsive table-scroll">

                              <template v-if="vesselsWithCrewsCurrentOnBoard.length === 0">
                                <table class="table table-bordered">
                                  <thead>
                                  <tr>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">Ship Name</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">Flag</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">Fleet</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">Master</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">c/mate</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">2/mate</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">Add 2/mate</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">3/mate</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">c/engr</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">1a/e</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">2a/e</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">3a/e</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">Bosun</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">a/b</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">o/s</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">#1olr</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">olr</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">c/cook</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">2/cook</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">m/man</th>
                                    <th style="background-color: #e1e1e1; border: 1px solid #c3c3c3" class="text-uppercase text-center">total</th>
                                  </tr>
                                  </thead>

                                  <tbody>
                                  <tr>
                                    <td colspan="100%">
                                      <app-loading :message="'Fetching CMS data, Please wait...'"></app-loading>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>

                              </template>

<!--                              <vue-good-table-->
<!--                                v-else-->
<!--                                :columns="summaryDataTableColumns"-->
<!--                                :rows="summaryPerVesselData"-->
<!--                                :sort-options="{-->
<!--                                  enabled: true,-->
<!--                                  initialSortBy: {-->
<!--                                    field: 'name',-->
<!--                                    type: 'asc'-->
<!--                                  }-->
<!--                                }"-->
<!--                              />-->

                              <table v-else class="table table-bordered crew-table">
                                <thead>
                                <tr>
                                  <th class="sticky-col text-center sticky-header-background">
                                    SHIP NAME
                                    <span class="sort-icons float-right">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'name' && sort.order === 'asc' }"
                                        @click="setSort('name', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'name' && sort.order === 'desc' }"
                                        @click="setSort('name', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="sticky-col text-center sticky-header-background">
                                    FLAG
                                    <span class="sort-icons float-right">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'flag' && sort.order === 'asc' }"
                                        @click="setSort('flag', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'flag' && sort.order === 'desc' }"
                                        @click="setSort('flag', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="sticky-col text-center sticky-header-background">
                                    FLEET
                                    <span class="sort-icons float-right">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'fleet' && sort.order === 'asc' }"
                                        @click="setSort('fleet', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'fleet' && sort.order === 'desc' }"
                                        @click="setSort('fleet', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 90px;
                                    max-width: 90px;
                                    white-space: nowrap;
                                  ">
                                    MASTER
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'master_count' && sort.order === 'asc' }"
                                        @click="setSort('master_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'master_count' && sort.order === 'desc' }"
                                        @click="setSort('master_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 80px;
                                    max-width: 80px;
                                    white-space: nowrap;
                                  ">
                                    C/MATE
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'c_mate_count' && sort.order === 'asc' }"
                                        @click="setSort('c_mate_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'c_mate_count' && sort.order === 'desc' }"
                                        @click="setSort('c_mate_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 80px;
                                    max-width: 80px;
                                    white-space: nowrap;
                                  ">
                                    2/MATE
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'second_mate_count' && sort.order === 'asc' }"
                                        @click="setSort('second_mate_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'second_mate_count' && sort.order === 'desc' }"
                                        @click="setSort('second_mate_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 110px;
                                    max-width: 110px;
                                    white-space: nowrap;
                                  ">
                                    ADD 2/MATE
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'add_second_mate_count' && sort.order === 'asc' }"
                                        @click="setSort('add_second_mate_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'add_second_mate_count' && sort.order === 'desc' }"
                                        @click="setSort('add_second_mate_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 80px;
                                    max-width: 80px;
                                    white-space: nowrap;
                                  ">
                                    3/MATE
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'third_mate_count' && sort.order === 'asc' }"
                                        @click="setSort('third_mate_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'third_mate_count' && sort.order === 'desc' }"
                                        @click="setSort('third_mate_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 80px;
                                    max-width: 80px;
                                    white-space: nowrap;
                                  ">
                                    C/ENGR
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'chief_engineer_count' && sort.order === 'asc' }"
                                        @click="setSort('chief_engineer_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'chief_engineer_count' && sort.order === 'desc' }"
                                        @click="setSort('chief_engineer_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 60px;
                                    max-width: 60px;
                                    white-space: nowrap;
                                  ">
                                    1A/E
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'first_assistant_engineer_count' && sort.order === 'asc' }"
                                        @click="setSort('first_assistant_engineer_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'first_assistant_engineer_count' && sort.order === 'desc' }"
                                        @click="setSort('first_assistant_engineer_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 60px;
                                    max-width: 60px;
                                    white-space: nowrap;
                                  ">
                                    2A/E
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'second_assistant_engineer_count' && sort.order === 'asc' }"
                                        @click="setSort('second_assistant_engineer_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'second_assistant_engineer_count' && sort.order === 'desc' }"
                                        @click="setSort('second_assistant_engineer_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 60px;
                                    max-width: 60px;
                                    white-space: nowrap;
                                  ">
                                    3A/E
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'third_assistant_engineer_count' && sort.order === 'asc' }"
                                        @click="setSort('third_assistant_engineer_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'third_assistant_engineer_count' && sort.order === 'desc' }"
                                        @click="setSort('third_assistant_engineer_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 80px;
                                    max-width: 80px;
                                    white-space: nowrap;
                                  ">
                                    BOSUN
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'bosun_count' && sort.order === 'asc' }"
                                        @click="setSort('bosun_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'bosun_count' && sort.order === 'desc' }"
                                        @click="setSort('bosun_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 60px;
                                    max-width: 60px;
                                    white-space: nowrap;
                                  ">
                                    A/B
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'able_bodied_seaman_count' && sort.order === 'asc' }"
                                        @click="setSort('able_bodied_seaman_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'able_bodied_seaman_count' && sort.order === 'desc' }"
                                        @click="setSort('able_bodied_seaman_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 60px;
                                    max-width: 60px;
                                    white-space: nowrap;
                                  ">
                                    O/S
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'ordinary_seaman_count' && sort.order === 'asc' }"
                                        @click="setSort('ordinary_seaman_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'ordinary_seaman_count' && sort.order === 'desc' }"
                                        @click="setSort('ordinary_seaman_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 100px;
                                    max-width: 100px;
                                    white-space: nowrap;
                                  ">
                                    #1 OLR
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'no_1_oiler_count' && sort.order === 'asc' }"
                                        @click="setSort('no_1_oiler_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'no_1_oiler_count' && sort.order === 'desc' }"
                                        @click="setSort('no_1_oiler_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 60px;
                                    max-width: 60px;
                                    white-space: nowrap;
                                  ">
                                    OLR
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'oiler_count' && sort.order === 'asc' }"
                                        @click="setSort('oiler_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'oiler_count' && sort.order === 'desc' }"
                                        @click="setSort('oiler_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 60px;
                                    max-width: 60px;
                                    white-space: nowrap;
                                  ">
                                    WPR
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'wiper_count' && sort.order === 'asc' }"
                                        @click="setSort('wiper_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'wiper_count' && sort.order === 'desc' }"
                                        @click="setSort('wiper_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 80px;
                                    max-width: 80px;
                                    white-space: nowrap;
                                  ">
                                    C/COOK
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'chief_cook_count' && sort.order === 'asc' }"
                                        @click="setSort('chief_cook_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'chief_cook_count' && sort.order === 'desc' }"
                                        @click="setSort('chief_cook_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 80px;
                                    max-width: 80px;
                                    white-space: nowrap;
                                  ">
                                    2/COOK
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'second_cook_count' && sort.order === 'asc' }"
                                        @click="setSort('second_cook_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'second_cook_count' && sort.order === 'desc' }"
                                        @click="setSort('second_cook_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center" style="
                                    min-width: 80px;
                                    max-width: 80px;
                                    white-space: nowrap;
                                  ">
                                    M/MAN
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'messman_count' && sort.order === 'asc' }"
                                        @click="setSort('messman_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'messman_count' && sort.order === 'desc' }"
                                        @click="setSort('messman_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                  <th class="text-center font-weight-bold h6" style="
                                    min-width: 90px;
                                    max-width: 90px;
                                    white-space: nowrap;
                                  ">
                                    TOTAL
                                    <span class="sort-icons">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'total_count' && sort.order === 'asc' }"
                                        @click="setSort('total_count', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'total_count' && sort.order === 'desc' }"
                                        @click="setSort('total_count', 'desc')"
                                      ></i>
                                    </span>
                                  </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in sortedSummaryPerVesselData" :key="index">
                                  <td class="text-center sticky-col">{{ row.name }}</td>
                                  <td class="text-center sticky-col">{{ row.flag }}</td>
                                  <td class="text-center sticky-col">{{ row.fleet }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.master_count > 0 }">{{ row.master_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.c_mate_count > 0 }">{{ row.c_mate_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.second_mate_count > 0 }">{{ row.second_mate_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.add_second_mate_count > 0 }">{{ row.add_second_mate_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.third_mate_count > 0 }">{{ row.third_mate_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.chief_engineer_count > 0 }">{{ row.chief_engineer_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.first_assistant_engineer_count > 0 }">{{ row.first_assistant_engineer_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.second_assistant_engineer_count > 0 }">{{ row.second_assistant_engineer_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.third_assistant_engineer_count > 0 }">{{ row.third_assistant_engineer_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.bosun_count > 0 }">{{ row.bosun_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.able_bodied_seaman_count > 0 }">{{ row.able_bodied_seaman_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.ordinary_seaman_count > 0 }">{{ row.ordinary_seaman_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.no_1_oiler_count > 0 }">{{ row.no_1_oiler_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.oiler_count > 0 }">{{ row.oiler_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.wiper_count > 0 }">{{ row.wiper_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.chief_cook_count > 0 }">{{ row.chief_cook_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.second_cook_count > 0 }">{{ row.second_cook_count }}</td>
                                  <td class="text-center" :class="{ 'font-weight-bold text-primary': row.messman_count > 0 }">{{ row.messman_count }}</td>

                                  <td class="text-center font-weight-bold h6">{{ row.total_count }}</td>
                                </tr>
                                </tbody>
                              </table>

                            </div>
                          </div>
                          <div class="tab-pane fade show active" v-else-if="crewSummaryModule === 'per_manning_assignment'" id="pills-summary-per-manning-assignment-tab-container" role="tabpanel" aria-labelledby="pills-graphs-tab">
                            <div class="table-responsive table-scroll">
                              <table class="table table-bordered crew-table">
                                <thead>
                                  <tr>
                                    <th class="sticky-col text-center sticky-header-background">
                                      SHIP NAME
                                      <span class="sort-icons float-right">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'name' && sort.order === 'asc' }"
                                        @click="setSort('name', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'name' && sort.order === 'desc' }"
                                        @click="setSort('name', 'desc')"
                                      ></i>
                                    </span>
                                    </th>
                                    <th class="sticky-col text-center sticky-header-background">
                                      FLAG
                                      <span class="sort-icons float-right">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'flag' && sort.order === 'asc' }"
                                        @click="setSort('flag', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'flag' && sort.order === 'desc' }"
                                        @click="setSort('flag', 'desc')"
                                      ></i>
                                    </span>
                                    </th>
                                    <th class="sticky-col text-center sticky-header-background">
                                      FLEET
                                      <span class="sort-icons float-right">
                                      <i
                                        class="arrow up"
                                        :class="{ active: sort.field === 'fleet' && sort.order === 'asc' }"
                                        @click="setSort('fleet', 'asc')"
                                      ></i>
                                      <i
                                        class="arrow down"
                                        :class="{ active: sort.field === 'fleet' && sort.order === 'desc' }"
                                        @click="setSort('fleet', 'desc')"
                                      ></i>
                                    </span>
                                    </th>
                                    <th class="sticky-col text-center sticky-header-background" style="z-index: 59 !important"></th>
                                    <th class="sticky-col text-center sticky-header-background" style="z-index: 59 !important">
                                      TOTAL
                                      <span class="sort-icons float-right">
                                        <i
                                          class="arrow up"
                                          :class="{ active: sort.field === 'total' && sort.order === 'asc' }"
                                          @click="setSort('total', 'asc')"
                                        ></i>
                                        <i
                                          class="arrow down"
                                          :class="{ active: sort.field === 'total' && sort.order === 'desc' }"
                                          @click="setSort('total', 'desc')"
                                        ></i>
                                      </span>
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <template v-if="vesselsWithCrewsCurrentOnBoard.length === 0">
                                    <tr>
                                      <td colspan="100%">
                                        <app-loading :message="'Fetching CMS data, Please wait...'"></app-loading>
                                      </td>
                                    </tr>
                                  </template>
                                  <template v-else>
                                    <tr v-for="(row, index) in sortedSummaryPerManningAssignmentData" :key="index">
                                      <td class="text-center align-middle sticky-col">{{ row.name }}</td>
                                      <td class="text-center align-middle sticky-col">{{ row.flag }}</td>
                                      <td class="text-center align-middle sticky-col">{{ row.fleet }}</td>
                                      <td class="fixed-cell">
<!--                                        <div class="row">-->
<!--                                          <div :class="['col-md-6', {'mb-2': ((index+1) % 2) === 1 && ((index+1) !== 1 || row.manning?.length > 2) && (index+1) < row.manning?.length -1}]" v-for="(manning, index) in row.manning" :key="index">-->
<!--                                            {{manning.manning_name}} - <span class="font-weight-bolder">{{ manning.total_manning }}</span>-->
<!--                                          </div>-->
<!--                                        </div>-->
                                        <table class="table-no-border">
                                          <tbody>
                                          <tr v-for="rowIndex in Math.ceil(row.manning.length / 2)" :key="rowIndex">
                                            <td v-if="row.manning[(rowIndex-1)*2]" class="font-weight-bolder">
                                              {{ row.manning[(rowIndex-1)*2].manning_name }} -
                                              <span class="font-weight-bolder text-danger">{{ row.manning[(rowIndex-1)*2].total_manning }}</span>
                                            </td>
                                            <td v-if="row.manning[(rowIndex-1)*2 + 1]" class="font-weight-bolder">
                                              {{ row.manning[(rowIndex-1)*2 + 1].manning_name }} -
                                              <span class="font-weight-bolder text-danger">{{ row.manning[(rowIndex-1)*2 + 1].total_manning }}</span>
                                            </td>
                                          </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                      <td class="text-center align-middle">{{ row.total }}</td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="tab-pane fade show active" v-else-if="crewSummaryModule === 'per_crew_age'" id="pills-summary-per-vessel-tab-container" role="tabpanel" aria-labelledby="pills-graphs-tab">
                            <div v-if="ageAndRankStats.length > 0">
                              <summary-per-crew-age-container
                                :data="ageAndRankStats"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3 mb-3" v-if="crewSummaryModule === 'per_manning' && totalCrew.length > 0">
                <div class="col-12">
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <button class="main-tabs nav-link text-uppercase font-weight-bold active" id="pills-onboard-graph-tab" data-toggle="pill" data-target="#pills-onboard-graph" type="button" role="tab" aria-controls="pills-onboard-graph" aria-selected="true">Pie Graph Per Manning Company</button>
                      <button class="main-tabs nav-link text-uppercase font-weight-bold" id="pills-onboard-bar-graph-tab" data-toggle="pill" data-target="#pills-onboard-bar-graph" type="button" role="tab" aria-controls="pills-onboard-bar-graph" aria-selected="false">Bar Graph Per Vessel Manning Company</button>
                    </div>
                  </nav>
                  <div class="tab-content mt-3" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="pills-onboard-graph" role="tabpanel" aria-labelledby="pills-onboard-graph-tab">
                      <summary-per-manning-graph-container
                        :data="totalCrew"
                      />
                    </div>
                    <div class="tab-pane fade" id="pills-onboard-bar-graph" role="tabpanel" aria-labelledby="pills-onboard-bar-graph-tab">
                      <SummaryPerVesselManningGraphContainer />
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!--END MANNING TAB-->
            <!--MACHINERY TAB-->
            <div class="tab-pane fade" id="pills-machinery-graphs" role="tabpanel" aria-labelledby="pills-machinery-graphs-tab">
              <div class="row">
                <!-- By Main Engine -->
                <div class="col-md-6">
                  <div class="card shadow-sm rounded mb-3 mt-3">
                    <div class="card-body h-100">
                      <div class="row">
                        <div class="col-8">
                          <div class="text-uppercase font-weight-bold h6">By Main Engine</div>
                        </div>
                        <div class="col-4" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                          <button class="ml-2 float-right e-btn e-btn-blue-gray force-white-all"
                                  @click="downloadIndividualGraph('vessel-pie-main-engine-individual')"
                          >
                            <font-awesome-icon class="mr-1" icon="download"/> Download Graph
                          </button>
                        </div>
                      </div>
                      <hr>
                      <VesselRecordMainEnginePieChart
                        :key="$route.params.report_type + '_' + vesselRecordByMainEngineSeries.length"
                        :series="vesselRecordByMainEngineSeries"
                        :labels="vesselRecordByMainEngineLabels.map(str => str.toUpperCase())"
                      />
                    </div>
                  </div>
                </div>

                <!-- By Diesel Generator -->
                <div class="col-md-6">
                  <div class="card shadow-sm rounded mb-3 mt-3">
                    <div class="card-body h-100">
                      <div class="row">
                        <div class="col-8">
                          <div class="text-uppercase font-weight-bold h6">By Diesel Generator</div>
                        </div>
                        <div class="col-4" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                          <button class="ml-2 float-right e-btn e-btn-blue-gray force-white-all"
                                  @click="downloadIndividualGraph('vessel-pie-diesel-generator-individual')"
                          >
                            <font-awesome-icon class="mr-1" icon="download"/> Download Graph
                          </button>
                        </div>
                      </div>
                      <hr>
                      <VesselRecordDieselGeneratorPieChart
                        :key="$route.params.report_type + '_' + vesselRecordByDieselGeneratorSeries.length"
                        :series="vesselRecordByDieselGeneratorSeries"
                        :labels="vesselRecordByDieselGeneratorLabels.map(str => str.toUpperCase())"
                      />
                    </div>
                  </div>
                </div>

                <!-- By Turbo Charger -->
                <div class="col-md-6">
                  <div class="card shadow-sm rounded mb-3 mt-3">
                    <div class="card-body h-100">
                      <div class="row">
                        <div class="col-8">
                          <div class="text-uppercase font-weight-bold h6">By Turbo Charger</div>
                        </div>
                        <div class="col-4" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                          <button class="ml-2 float-right e-btn e-btn-blue-gray force-white-all"
                                  @click="downloadIndividualGraph('vessel-pie-turbo-charger-individual')"
                          >
                            <font-awesome-icon class="mr-1" icon="download"/> Download Graph
                          </button>
                        </div>
                      </div>
                      <hr>
                      <VesselRecordTurboChargerPieChart
                        :key="$route.params.report_type + '_' + vesselRecordByTurboChargerSeries.length"
                        :series="vesselRecordByTurboChargerSeries"
                        :labels="vesselRecordByTurboChargerLabels.map(str => str.toUpperCase())"
                      />
                    </div>
                  </div>
                </div>

                <!-- By Auxiliary Boiler -->
                <div class="col-md-6">
                  <div class="card shadow-sm rounded mb-3 mt-3">
                    <div class="card-body h-100">
                      <div class="row">
                        <div class="col-8">
                          <div class="text-uppercase font-weight-bold h6">By Auxiliary Boiler</div>
                        </div>
                        <div class="col-4" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                          <button class="ml-2 float-right e-btn e-btn-blue-gray force-white-all"
                                  @click="downloadIndividualGraph('vessel-pie-auxiliary-boiler-individual')"
                          >
                            <font-awesome-icon class="mr-1" icon="download"/> Download Graph
                          </button>
                        </div>
                      </div>
                      <hr>
                      <VesselRecordAuxiliaryBoilerPieChart
                        :key="$route.params.report_type + '_' + vesselRecordByAuxiliaryBoilerSeries.length"
                        :series="vesselRecordByAuxiliaryBoilerSeries"
                        :labels="vesselRecordByAuxiliaryBoilerLabels.map(str => str.toUpperCase())"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--END MACHINERY TAB-->

            <!--FOR SUMMARY PDF EXPORT-->

            <template v-if="downloadingReportSummary">
              <div :style="{ 'z-index': $route.params.report_type === 'flag' ? 2 : 1, position: 'absolute', left : '10000px' }">
                <div class="row" v-if="$route.params.report_type === 'flag' && vesselRecordByFlagSeries.length > 0">
                  <div class="col-12">
                    <div class="card shadow-sm rounded mb-3 mt-3">
                      <div class="card-body">
                        <div>
                          <div ref="flagChartPrint">
                            <VesselPrintFlagPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByFlagSeries.length"
                              :series="vesselRecordByFlagSeries"
                              :labels="vesselRecordByFlagLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-flag"
                            />
                          </div>
                          <div ref="flagIndividualChartPrint">
                            <VesselPrintFlagIndividualPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByFlagSeries.length"
                              :series="vesselRecordByFlagSeries"
                              :labels="vesselRecordByFlagLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-flag-individual"
                            />
                          </div>
                          <div ref="ageChartPrint">
                            <VesselPrintAgePieChart
                              :key="$route.params.report_type + '_' + vesselRecordByAgeSeries.length"
                              :series="vesselRecordByAgeSeries"
                              :labels="vesselRecordByAgeLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-age"
                            />
                          </div>
                          <div ref="ageIndividualChartPrint">
                            <VesselPrintAgeIndividualPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByAgeSeries.length"
                              :series="vesselRecordByAgeSeries"
                              :labels="vesselRecordByAgeLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-age-individual"
                            />
                          </div>
                          <div ref="shipBuilderChartPrint">
                            <VesselShipBuilderGraph
                              ref="vessel-pie-ship-type"
                              :summary-print="true">
                            </VesselShipBuilderGraph>
                          </div>
                          <div ref="shipBuilderIndividualChartPrint">
                            <VesselPrintShipBuilderIndividualChart
                              :key="$route.params.report_type + '_' + vesselRecordByShipBuilderSeries.length"
                              :series="vesselRecordByShipBuilderSeries"
                              :labels="vesselRecordByShipBuilderLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-ship-builder-individual" />
                          </div>
                          <div ref="shipTypeChartPrint">
                            <VesselPrintShipTypePieChart
                              :key="$route.params.report_type + '_' + vesselRecordByShipTypeSeries.length"
                              :series="vesselRecordByShipTypeSeries"
                              :labels="vesselRecordByShipTypeLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-ship-type" />
                          </div>
                          <div ref="shipTypeIndividualChartPrint">
                            <VesselPrintShipTypeIndividualPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByShipTypeSeries.length"
                              :series="vesselRecordByShipTypeSeries"
                              :labels="vesselRecordByShipTypeLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-ship-type-individual" />
                          </div>
                          <div ref="mainEngineChartPrint">
                            <VesselPrintMainEnginePieChart
                              :key="$route.params.report_type + '_' + vesselRecordByMainEngineSeries.length"
                              :series="vesselRecordByMainEngineSeries"
                              :labels="vesselRecordByMainEngineLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-main-engine"
                            />
                          </div>
                          <div ref="mainEngineIndividualChartPrint">
                            <VesselPrintMainEngineIndividualPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByMainEngineSeries.length"
                              :series="vesselRecordByMainEngineSeries"
                              :labels="vesselRecordByMainEngineLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-main-engine-individual"
                            />
                          </div>
                          <div ref="dieselGeneratorChartPrint">
                            <VesselPrintDieselGeneratorPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByDieselGeneratorSeries.length"
                              :series="vesselRecordByDieselGeneratorSeries"
                              :labels="vesselRecordByDieselGeneratorLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-diesel-generator"
                            />
                          </div>
                          <div ref="dieselGeneratorIndividualChartPrint">
                            <VesselPrintDieselGeneratorIndividualPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByDieselGeneratorSeries.length"
                              :series="vesselRecordByDieselGeneratorSeries"
                              :labels="vesselRecordByDieselGeneratorLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-diesel-generator-individual"
                            />
                          </div>
                          <div ref="turboChargerChartPrint">
                            <VesselPrintTurboChargerPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByTurboChargerSeries.length"
                              :series="vesselRecordByTurboChargerSeries"
                              :labels="vesselRecordByTurboChargerLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-turbo-charger"
                            />
                          </div>
                          <div ref="turboChargerIndividualChartPrint">
                            <VesselPrintTurboChargerIndividualPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByTurboChargerSeries.length"
                              :series="vesselRecordByTurboChargerSeries"
                              :labels="vesselRecordByTurboChargerLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-turbo-charger-individual"
                            />
                          </div>
                          <div ref="auxiliaryBoilerChartPrint">
                            <VesselPrintAuxiliaryBoilerPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByAuxiliaryBoilerSeries.length"
                              :series="vesselRecordByAuxiliaryBoilerSeries"
                              :labels="vesselRecordByAuxiliaryBoilerLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-auxiliary-boiler"
                            />
                          </div>
                          <div ref="auxiliaryBoilerIndividualChartPrint">
                            <VesselPrintAuxiliaryBoilerIndividualPieChart
                              :key="$route.params.report_type + '_' + vesselRecordByAuxiliaryBoilerSeries.length"
                              :series="vesselRecordByAuxiliaryBoilerSeries"
                              :labels="vesselRecordByAuxiliaryBoilerLabels.map(str => str.toUpperCase())"
                              ref="vessel-pie-auxiliary-boiler-individual"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>


    <div class="modal fade" id="vesselSummaryList" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="small e-tbl">
              <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
              <tr>
                <th class="align-middle text-center" style="width: 1em" scope="col">#</th>
                <th class="align-middle text-center" scope="col">VESSEL NAME</th>
                <th class="align-middle text-center" scope="col">FLAG</th>
                <th class="align-middle text-center" scope="col">MANAGEMENT COMPANY</th>
                <th class="align-middle text-center" scope="col">MANAGEMENT OFFICE</th>
                <th class="align-middle text-center" scope="col">FLEET</th>
                <th class="align-middle text-center" scope="col">ACTION</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="modalLoading">
                <tr>
                  <td colspan="100%">
                    <app-loading></app-loading>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(data,index) in vesselSummaryList ">
                  <td class="align-middle text-center text-uppercase">{{ index + 1 }}</td>
                  <td class="align-middle text-center text-uppercase">{{ data?.name }}</td>
                  <td class="align-middle text-center text-uppercase">{{ data?.flag?.name }}</td>
                  <td class="align-middle text-center text-uppercase">{{ data?.management_company?.name }}</td>
                  <td class="align-middle text-center text-uppercase">{{ data?.management_office?.name }}</td>
                  <td class="align-middle text-center text-uppercase">{{ data?.fleet?.name }}</td>
                  <td class="align-middle text-center text-uppercase">
                    <button class="e-btn e-btn-blue e-btn-sm e-text-white my-1" @click="showVessel(data.id)">
                      <font-awesome-icon icon="eye"  />
                      View
                    </button>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!--SUMMARY PER RANK MODAL-->
    <div class="modal fade" id="crewSummaryPerRank" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title my-auto text-uppercase font-weight-bold" id="exampleModalLabel">{{ this.rankTitleSelected }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <template v-if="modalLoading">
                  <app-loading></app-loading>
                </template>
                <template v-else>
                  <table class="table table-bordered">
                    <thead>
                    <tr>
                      <th class="text-center font-weight-bold text-uppercase align-middle">No.</th>
                      <th class="text-center font-weight-bold text-uppercase align-middle">Name</th>
                      <th class="text-center font-weight-bold text-uppercase align-middle">Vessel</th>
                      <th class="text-center font-weight-bold text-uppercase align-middle">Rank</th>
                      <th class="text-center font-weight-bold text-uppercase align-middle">Nationality</th>
                      <th class="text-center font-weight-bold text-uppercase align-middle">Embarkation Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(data, index) in rankSelected" :key="index">
                      <td class="text-center align-middle">{{ index+1 }}</td>
                      <td class="text-center align-middle">{{ data.name }}</td>
                      <td class="text-center align-middle text-uppercase">{{ data.vessel }}</td>
                      <td class="text-center align-middle text-uppercase" style="max-width: 100px !important;">{{ data.rank }}</td>
                      <td class="text-center align-middle text-uppercase" style="max-width: 100px !important;">{{ data.nationality }}</td>
                      <td class="text-center align-middle text-uppercase" style="max-width: 100px !important;">{{ data.embarkationDate }}</td>
                    </tr>
                    </tbody>
                  </table>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--END SUMMARY PER RANK MODAL  -->
  </div>
</template>

<script>
import axios from 'axios';
import html2canvas from 'html2canvas';
import {permissionMixin} from "@/mixins/permissionMixins";
import {mapActions, mapGetters} from "vuex";
import VesselRecordPieChart from "@/components/dashboard/number-of-management/VesselRecordPieChart.vue";
import AppLoading from "@/components/elements/AppLoading.vue";
import {VesselService} from "@/services/VesselService";
import VesselRecordFlagPieChart from "@/components/dashboard/number-of-management/VesselRecordFlagPieChart.vue";
import VesselRecordAgePieChart from "@/components/dashboard/number-of-management/VesselRecordAgePieChart.vue";
import VesselRecordShipTypePieChart from "@/components/dashboard/number-of-management/VesselRecordShipTypePieChart.vue";
import VesselRecordMainEnginePieChart from "@/components/dashboard/number-of-management/VesselRecordMainEnginePieChart.vue";
import VesselRecordDieselGeneratorPieChart from "@/components/dashboard/number-of-management/VesselRecordDieselGeneratorPieChart.vue";
import VesselRecordTurboChargerPieChart from "@/components/dashboard/number-of-management/VesselRecordTurboChargerPieChart.vue";
import VesselRecordAuxiliaryBoilerPieChart from "@/components/dashboard/number-of-management/VesselRecordAuxiliaryBoilerPieChart.vue";
import {TOKEN_NAME, VESSEL_MANAGEMENT} from "@/services/ConstantService";
import VesselPrintAgePieChart from "@/components/dashboard/number-of-management/VesselPrintAgePieChart.vue";
import VesselPrintAgeIndividualPieChart from "@/components/dashboard/number-of-management/VesselPrintAgePieIndividualChart.vue";
import VesselPrintFlagPieChart from "@/components/dashboard/number-of-management/VesselPrintFlagPieChart.vue";
import VesselPrintFlagIndividualPieChart from "@/components/dashboard/number-of-management/VesselPrintFlagIndividualPieChart.vue";
import VesselPrintShipTypePieChart from "@/components/dashboard/number-of-management/VesselPrintShipTypePieChart.vue";
import VesselPrintShipTypeIndividualPieChart from "@/components/dashboard/number-of-management/VesselPrintShipTypeIndividualPieChart.vue";
import VesselPrintMainEnginePieChart from "@/components/dashboard/number-of-management/VesselPrintMainEngineChart.vue";
import VesselPrintMainEngineIndividualPieChart from "@/components/dashboard/number-of-management/VesselPrintMainEngineIndividualChart.vue";
import VesselPrintDieselGeneratorPieChart from "@/components/dashboard/number-of-management/VesselPrintDieselGeneratorPieChart.vue";
import VesselPrintDieselGeneratorIndividualPieChart from "@/components/dashboard/number-of-management/VesselPrintDieselGeneratorIndividualPieChart.vue";
import VesselPrintTurboChargerPieChart from "@/components/dashboard/number-of-management/VesselPrintTurboChargerPieChart.vue";
import VesselPrintTurboChargerIndividualPieChart from "@/components/dashboard/number-of-management/VesselPrintTurboChargerIndividualPieChart.vue";
import VesselPrintAuxiliaryBoilerPieChart from "@/components/dashboard/number-of-management/VesselPrintAuxiliaryBoilerPieChart.vue";
import VesselPrintAuxiliaryBoilerIndividualPieChart from "@/components/dashboard/number-of-management/VesselPrintAuxiliaryBoilerIndividualPieChart.vue";
import {KeyService} from "@/services/KeyService";
import SummaryOnBoardCrewPieChart from "@/components/dashboard/number-of-management/SummaryOnBoardCrewPieChart.vue";
import SummaryTotalCrewBarGraph from "@/components/dashboard/number-of-management/SummaryTotalCrewBarGraph.vue";
import SummaryPerNationalityBarGraph
  from "@/components/dashboard/number-of-management/SummaryPerNationalityBarGraph.vue";
import SummaryPerManningGraphContainer
  from "@/components/dashboard/number-of-management/SummaryPerManningGraphContainer.vue";
import SummaryPerVesselManningGraphContainer
  from "@/components/dashboard/number-of-management/SummaryPerVesselManningGraphContainer.vue";
import VesselRecordShipBuilderPieChart
  from "@/components/dashboard/number-of-management/VesselRecordShipBuilderPieChart.vue";
import VesselPrintShipBuilderIndividualChart
  from "@/components/dashboard/number-of-management/VesselPrintShipBuilderIndividualChart.vue";
import VesselPrintShipBuilderChart
  from "@/components/dashboard/number-of-management/VesselPrintShipBuilderChart.vue";
import SummaryPerCrewAgeContainer from "@/components/dashboard/number-of-management/SummaryPerCrewAgeContainer.vue";
import VesselShipBuilderGraph
  from "@/components/dashboard/number-of-management/vessel-graphs/VesselShipBuilderGraph.vue";
import {GlobalService} from "@/services/GlobalService";

export default {
  name: 'NumberOfManagement',
  mixins:[permissionMixin],
  data(){
    return {
      sort: {
        field: null,
        order: null
      },
      vesselRByFlagSeries: [],
      vesselRByFlagLabels: [],
      vesselRByAgeSeries: [],
      vesselRByAgeLabels: [],
      selectedFlag: null,
      selectedAgeRange: null,
      flagDataReady: false,
      ageDataReady: false,
      totalCrew: [],
      sumTotal: 0,
      cardRankTitle: "Summary Per Manning Onboard",
      rankSelected: [],
      rankTitleSelected: null,

      loading : true,
      modalLoading : false,
      swalOptions: {
        'title': 'Sweet Alert Title',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      },
      summaryOnBoardActiveTab : 'details',
      summaryTotalCrewActiveTab : 'details',
      summaryModuleTab : 'graphs',
      crewSummaryModule : 'per_nationality',
      vesselsWithCrewsCurrentOnBoard : [],
      onboardCrewNationalityStats : [],
      activeTabPerRank: 'Onboard',
      downloadingReportSummary : false
    }
  },
  components: {
    SummaryPerCrewAgeContainer,
    VesselShipBuilderGraph,
    SummaryPerManningGraphContainer,
    SummaryPerVesselManningGraphContainer,
    VesselPrintShipBuilderIndividualChart,
    VesselPrintShipBuilderChart,
    VesselRecordShipBuilderPieChart,
    SummaryPerNationalityBarGraph,
    SummaryTotalCrewBarGraph,
    SummaryOnBoardCrewPieChart,
    VesselRecordShipTypePieChart,
    VesselRecordFlagPieChart,
    VesselRecordAgePieChart,
    VesselRecordPieChart,
    VesselPrintAgePieChart,
    VesselPrintAgeIndividualPieChart,
    VesselPrintFlagPieChart,
    VesselPrintFlagIndividualPieChart,
    VesselPrintShipTypePieChart,
    VesselPrintShipTypeIndividualPieChart,
    VesselPrintMainEnginePieChart,
    VesselPrintMainEngineIndividualPieChart,
    VesselPrintDieselGeneratorPieChart,
    VesselPrintDieselGeneratorIndividualPieChart,
    VesselPrintTurboChargerPieChart,
    VesselPrintTurboChargerIndividualPieChart,
    VesselPrintAuxiliaryBoilerPieChart,
    VesselPrintAuxiliaryBoilerIndividualPieChart,
    VesselRecordMainEnginePieChart,
    VesselRecordDieselGeneratorPieChart,
    VesselRecordTurboChargerPieChart,
    VesselRecordAuxiliaryBoilerPieChart,
    AppLoading,
  },
  async mounted() {
    await this.getManningCrewStatsFromCms();
    // Both are lists; false (CMS down) leaves the tables and graphs empty.
    const vesselsWithCrewsCurrentOnBoard = await KeyService.getAllVesselsWithCurrentOnBoardCrews();
    this.vesselsWithCrewsCurrentOnBoard = Array.isArray(vesselsWithCrewsCurrentOnBoard) ? vesselsWithCrewsCurrentOnBoard : [];
    const onboardCrewNationalityStats = await KeyService.getOnboardCrewNationalityStats();
    this.onboardCrewNationalityStats = Array.isArray(onboardCrewNationalityStats) ? onboardCrewNationalityStats : [];
  },
  methods:{
    ...mapActions([
      'getDashboardVesselManagement',
      'getMngmtOfficeKeys',
      'getVesselSummaryList',
      'getAgeAndRankStats',
    ]),
    downloadIndividualGraph(componentRef){
      this.downloadingReportSummary = true;
      setTimeout(() => {
        this.$refs[componentRef].getGraphImage();
        this.downloadingReportSummary = false;
      }, 300)
    },
    setSort(field, order) {
      if (this.sort.field === field && this.sort.order === order) {
        this.sort = { field: null, order: null };
      } else {
        this.sort = { field, order };
      }
    },
    async getVesselListByParam(management_company_id, management_office_id, fleet_id, flag_id) {
      let param = {}
      if (management_company_id) {
        param.management_company_id = management_company_id;
      }
      if (management_office_id) {
        param.management_office_id = management_office_id;
      }
      if (fleet_id) {
        param.fleet_id = fleet_id;
      }
      if (flag_id) {
        param.flag_id = flag_id;
      }
      $('#vesselSummaryList').modal('show');
      this.modalLoading = true;
      await this.getVesselSummaryList({
        management_company_id,
        management_office_id,
        fleet_id,
        flag_id
      });
      this.modalLoading = false;
    },
    async showVessel(vesselId) {
      const route= this.$router.resolve(
        {
          name: 'VesselParticular',
          params: {
            id: vesselId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async downloadManagingVesselSummary() {
      swal.fire({
        'title': `DOWNLOADING MANAGING VESSEL SUMMARY<br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      const downloadResponse = await VesselService.downloadManagingVesselSummary();
      swal.close()
      let url = window.URL.createObjectURL(new Blob([downloadResponse.data],{type:'application/pdf'}))
      let filename=`summary_of_managing_vessels_${Date.now()}.pdf`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      // link.setAttribute('target','_blank');
      document.body.appendChild(link);
      link.click();
    },

    async downloadAllVesselSummary(){
      this.downloadingReportSummary = true;

      setTimeout(async () => {
        swal.fire({
          'title': `Exporting Vessel Report Summary`,
          'text': "Please wait...",
          'imageUrl': "https://img.icons8.com/color/400/pie-chart--v1.png",
          'imageWidth': 100,
          'imageHeight': 100,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        })
        swal.showLoading();

        try {
          const chartContainer1 = this.$refs.ageChartPrint;
          const chartContainer2 = this.$refs.flagChartPrint;
          const chartContainer3 = this.$refs.shipTypeChartPrint;
          const chartContainer4 = this.$refs.mainEngineChartPrint;
          const chartContainer5 = this.$refs.dieselGeneratorChartPrint;
          const chartContainer6 = this.$refs.turboChargerChartPrint;
          const chartContainer7 = this.$refs.auxiliaryBoilerChartPrint;
          const chartContainer8 = this.$refs.shipBuilderChartPrint;

          try {
            const canvas1 = await html2canvas(chartContainer1);
            const imageDataURL1 = canvas1.toDataURL('image/png');

            const canvas2 = await html2canvas(chartContainer2);
            const imageDataURL2 = canvas2.toDataURL('image/png');

            const canvas3 = await html2canvas(chartContainer3);
            const imageDataURL3 = canvas3.toDataURL('image/png');

            const canvas4 = await html2canvas(chartContainer4);
            const imageDataURL4 = canvas4.toDataURL('image/png');

            const canvas5 = await html2canvas(chartContainer5);
            const imageDataURL5 = canvas5.toDataURL('image/png');

            const canvas6 = await html2canvas(chartContainer6);
            const imageDataURL6 = canvas6.toDataURL('image/png');

            const canvas7 = await html2canvas(chartContainer7);
            const imageDataURL7 = canvas7.toDataURL('image/png');

            const canvas8 = await html2canvas(chartContainer8);
            const imageDataURL8 = canvas8.toDataURL('image/png');

            await this.sendImageToLaravel({ image1: imageDataURL1, image2: imageDataURL2, image3: imageDataURL3, image4: imageDataURL4, image5: imageDataURL5, image6: imageDataURL6, image7: imageDataURL7, image8: imageDataURL8 });

          } catch (error) {
            console.error('Error converting div to image:', error);
          }
        } catch (error) {
          console.error('An error occurred during one of the operations:', error);
        }
        this.downloadingReportSummary = false;
      }, 300)

    },

    async sendImageToLaravel(imageData) {
      try {
        const response = await axios.post('/kids/mergeSavedPdfs', imageData, {
          responseType: 'blob',
        });
        swal.close();
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.download = `summary_report_${Date.now()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error sending image to controller:', error);
      }
    },

    async getManningCrewStatsFromCms(){
        const token = localStorage.getItem(TOKEN_NAME);
        if (!token) return false;

        try {
          swal.fire({
            ...this.swalOptions,
            title: 'ESTABLISHING CONNECTION TO CMS'
          });
          swal.showLoading();
          const response = await axios.get('/kids/getManningCrewStats');
          this.totalCrew = response.data;
          swal.close();
          return true;

        } catch (error) {
          swal.close();
          if (localStorage.getItem(TOKEN_NAME)) {
            GlobalService.handleError(
              error,
              'GET MANNING CREW STATS FROM CMS SERVICE'
            );
          }
          return false;
        }
    },

    async getManningCrewFromCms(data, rank, status){
      if (!data || !rank) {
        return;
      }
      this.rankTitleSelected = rank.alias+" - "+data.name.toLowerCase();
      $('#crewSummaryPerRank').modal('show');
      this.modalLoading = true;
      await axios.get('/kids/getManningCrew',{
        params: {
          manning_id: rank.id,
          rank_id: data.id,
          status: status,

        },
      }).then(response => {
        this.rankSelected = response.data;
      }).catch(() => {
        this.rankSelected = [];
        $('#crewSummaryPerRank').modal('hide');
      }).finally(() => {
        this.modalLoading = false;
      })
    },

    getTotalSumOfOnboardRank(data){
      let sum = 0;
      this.totalCrew.forEach(aliasData => {
        const crewRank = aliasData.totalOnboardCrewPerRank.find(rank => rank.name === data);
        if (crewRank) {
          sum += crewRank.total;
        }
      });
      return sum;
    },
    getAllDataByRank(rankName, key) {
      const data = [];
      this.totalCrew.forEach(aliasData => {
        const crewRank = aliasData[key].find(rank => rank.name === rankName);
        if (crewRank) {
          data.push(crewRank);
        }
      });

      return data;
    },

    getTotalSumRank(data){
      let sum = 0;
      this.totalCrew.forEach(aliasData => {
        const crewRank = aliasData.totalCrewPerRank.find(rank => rank.name === data);
        if (crewRank) {
          sum += crewRank.total;
        }
      });
      return sum;
    },

    getTotalOfAllRanks() {
      let overallTotal = 0;
      this.totalCrew.forEach(aliasData => {
        aliasData.totalCrewPerRank.forEach(rank => {
          overallTotal += rank.total;
        });
      });
      return overallTotal;
    },

    getTotalOfAllOnboardRanks() {
      let overallTotal = 0;
      this.totalCrew.forEach(aliasData => {
        aliasData.totalOnboardCrewPerRank.forEach(rank => {
          overallTotal += rank.total;
        });
      });
      return overallTotal;
    },

    changeCardRankTitle(data) {
      if(data === 'Onboard'){
        this.cardRankTitle = "Summary Per Manning Onboard";
        this.summaryOnBoardActiveTab = 'details';
        this.activeTabPerRank = 'Onboard'
      }
      else{
        this.cardRankTitle = "Summary of Total Crew Per Rank";
        this.summaryTotalCrewActiveTab = 'details';
        this.activeTabPerRank = 'TotalCrew'
      }
    },

    async downloadCrewInfoSummary(fileType) {

      const crewSummaryModules = {
        per_manning: 'PER MANNING',
        per_rank: 'PER RANK',
        per_nationality: 'PER NATIONALITY',
        per_vessel: 'PER VESSEL',
        per_manning_assignment: 'PER MANNING ASSIGNMENT',
        per_crew_age: 'PER CREW AGE',
      }
      const params = {
        fileType,
        crewSummaryModule: this.crewSummaryModule,
        activeTabPerRank: this.activeTabPerRank,
      }

      try {
        swal.fire({
          'title': `GENERATING CREW SUMMARY ${crewSummaryModules[this.crewSummaryModule]} ${fileType === 'pdf' ? 'PDF' : 'EXCEL'} REPORT <br>Please wait.....`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        })

        swal.showLoading()
        const response = await axios.post('/kids/downloadCrewInfoSummary', params, {
          responseType: 'blob'
        });
        swal.close();

        let mime_type = fileType === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        let url = window.URL.createObjectURL(new Blob([response?.data], {type: mime_type}))

        fileType = (fileType !== 'pdf') ? 'xlsx' : 'pdf';

        let filename = `CREW_SUMMARY_${crewSummaryModules[this.crewSummaryModule].replace(/ /g, '_')}`;

        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {

      }

    },
  },

  async created() {
    await this.getMngmtOfficeKeys();
    await this.getDashboardVesselManagement();
    await this.getAgeAndRankStats();
    this.loading = false;
  },
  computed:{
    ...mapGetters([
      'mngmntOfficeKeys',
      'vesselManagement',
      'vesselSummaryList',
      'ageAndRankStats',
    ]),

    sortedSummaryPerVesselData() {
      if (!this.sort.field) {
        return this.summaryPerVesselData;
      }

      return [...this.summaryPerVesselData].sort((a, b) => {
        let valA = a[this.sort.field];
        let valB = b[this.sort.field];

        if (this.sort.order === 'asc') return valA > valB ? 1 : -1;
        if (this.sort.order === 'desc') return valA < valB ? 1 : -1;
        return 0;
      });
    },
    sortedSummaryPerManningAssignmentData() {
      if (!this.sort.field) {
        return this.summaryPerManningAssignmentData;
      }

      return [...this.summaryPerManningAssignmentData].sort((a, b) => {
        let valA = a[this.sort.field];
        let valB = b[this.sort.field];

        if (this.sort.order === 'asc') return valA > valB ? 1 : -1;
        if (this.sort.order === 'desc') return valA < valB ? 1 : -1;
        return 0;
      });
    },
    vesselRecordByFlagSeries() {
      return this.vesselManagement?.vesselRecordByFlag?.map(record => record);
    },
    vesselRecordByFlagLabels() {
      return this.vesselManagement?.vesselRecordByFlag?.map(record => record.name);
    },
    vesselRecordByAgeSeries() {
      return this.vesselManagement?.vesselRecordByAge?.map(record => record);
    },
    vesselRecordByAgeLabels() {
      return this.vesselManagement?.vesselRecordByAge?.map(record => record.name);
    },
    vesselRecordByShipTypeSeries() {
      return this.vesselManagement?.vesselRecordByShipType?.map(record => record);
    },
    vesselRecordByShipTypeLabels() {
      return this.vesselManagement?.vesselRecordByShipType?.map(record => record.name);
    },
    vesselRecordByShipBuilderSeries() {
      return this.vesselManagement?.vesselRecordByShipBuilder?.map(record => record);
    },
    vesselRecordByShipBuilderLabels() {
      return this.vesselManagement?.vesselRecordByShipBuilder?.map(record => record.name);
    },
    vesselRecordByMainEngineSeries() {
      return this.vesselManagement?.vesselRecordByMainEngine?.map(record => record);
    },
    vesselRecordByMainEngineLabels () {
      return this.vesselManagement?.vesselRecordByMainEngine?.map(record => record.name);
    },
    vesselRecordByDieselGeneratorSeries() {
      return this.vesselManagement?.vesselRecordByDieselGenerator?.map(record => record);
    },
    vesselRecordByDieselGeneratorLabels () {
      return this.vesselManagement?.vesselRecordByDieselGenerator?.map(record => record.name);
    },
    vesselRecordByTurboChargerSeries() {
      return this.vesselManagement?.vesselRecordByTurboCharger?.map(record => record);
    },
    vesselRecordByTurboChargerLabels () {
      return this.vesselManagement?.vesselRecordByTurboCharger?.map(record => record.name);
    },
    vesselRecordByAuxiliaryBoilerSeries() {
      return this.vesselManagement?.vesselRecordByAuxiliaryBoiler?.map(record => record);
    },
    vesselRecordByAuxiliaryBoilerLabels () {
      return this.vesselManagement?.vesselRecordByAuxiliaryBoiler?.map(record => record.name);
    },


    onBoardCrewRankLabels() {
      if (this.totalCrew.length === 0) {
        return [];
      }
      return this.totalCrew[0].totalOnboardCrewPerRank.map(item => item.name.toUpperCase());
    },

    onBoardCrewRankSeries() {
      if (this.totalCrew.length === 0) {
        return [];
      }

      return this.totalCrew[0].totalOnboardCrewPerRank.map(item => {
        return {
          id : item.id,
          name : item.name,
          count : this.getTotalSumOfOnboardRank(item.name),
          data : this.getAllDataByRank(item.name, 'totalOnboardCrewPerRank')
        }
      })
    },
    summaryPerManningAssignmentData() {
      return this.vesselsWithCrewsCurrentOnBoard.map(item => {
        const crews = Array.isArray(item.crews_onboarded)
          ? item.crews_onboarded
          : []

        const uniqueManningIds = [
          ...new Set(crews.map(c => c.manning_id))
        ]

        const result = uniqueManningIds.map(id => {
          const crewsForManning = crews.filter(c => c.manning_id === id);

          return {
            manning_name: crewsForManning[0]?.manning_name ?? '',
            manning_id: id,
            total_manning: crewsForManning.length
          };
        });

        return {
          name : item.vessel_name?.toUpperCase(),
          fleet : item.fleet?.toUpperCase() ?? '',
          flag : item.flag?.toUpperCase() ?? '',
          manning: result,
          total: item.crews_onboarded?.length,
        }
      })
    },
    hideDownloadButtonCrewSummary(){
      if (this.crewSummaryModule === 'per_rank') {
        if (this.activeTabPerRank === 'Onboard') {
          return this.summaryOnBoardActiveTab === 'details';
        }

        if (this.activeTabPerRank === 'TotalCrew') {
          return this.summaryTotalCrewActiveTab === 'details';
        }
      }

      return true;
    },
    summaryPerVesselData() {
      return this.vesselsWithCrewsCurrentOnBoard.map(item => {
        const master_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'master'
        }).length;

        const c_mate_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'c/mate'
        }).length;

        const second_mate_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === '2/mate'
        }).length;

        const add_second_mate_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === '2/mate' && crew.reliever_rank;
        }).length;

        const third_mate_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === '3/mate'
        }).length;

        const chief_engineer_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'c/engr'
        }).length;

        const first_assistant_engineer_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === '1a/e'
        }).length;


        const second_assistant_engineer_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === '2a/e'
        }).length

        const third_assistant_engineer_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === '3a/e'
        }).length

        const bosun_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'bosun'
        }).length;

        const able_bodied_seaman_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'a/b'
        }).length;

        const ordinary_seaman_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'o/s'
        }).length;

        const no_1_oiler_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === '#1olr'
        }).length;

        const oiler_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'olr'
        }).length;

        const wiper_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'wpr'
        }).length;

        const chief_cook_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'c/cook'
        }).length;

        const second_cook_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === '2/cook'
        }).length;

        const messman_count = item.crews_onboarded.filter(crew => {
          return crew.rank_alias1.trim().toLowerCase() === 'm/man'
        }).length;

        return {
          name : item.vessel_name?.toUpperCase(),
          fleet : item.fleet?.toUpperCase() ?? '',
          flag : item.flag?.toUpperCase() ?? '',
          master_count : master_count,
          c_mate_count : c_mate_count,
          second_mate_count : second_mate_count,
          add_second_mate_count : add_second_mate_count,
          third_mate_count : third_mate_count,
          chief_engineer_count : chief_engineer_count,
          first_assistant_engineer_count : first_assistant_engineer_count,
          second_assistant_engineer_count : second_assistant_engineer_count,
          third_assistant_engineer_count : third_assistant_engineer_count,
          bosun_count : bosun_count,
          able_bodied_seaman_count : able_bodied_seaman_count,
          ordinary_seaman_count : ordinary_seaman_count,
          no_1_oiler_count : no_1_oiler_count,
          oiler_count : oiler_count,
          wiper_count : wiper_count,
          chief_cook_count : chief_cook_count,
          second_cook_count : second_cook_count,
          messman_count : messman_count,
          total_count :
            master_count +
            c_mate_count +
            second_mate_count +
            add_second_mate_count +
            third_mate_count +
            chief_engineer_count +
            first_assistant_engineer_count +
            third_assistant_engineer_count +
            bosun_count +
            able_bodied_seaman_count +
            ordinary_seaman_count +
            no_1_oiler_count +
            oiler_count +
            wiper_count +
            chief_cook_count +
            second_cook_count +
            messman_count
        }
      })
    },
    summaryDataTableColumns() {
      return [
        {
          label : 'SHIP NAME',
          field : 'name',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center'
        },
        {
          label : 'FLAG',
          field : 'flag',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
        },
        {
          label : 'FLEET',
          field : 'fleet',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center'
        },
        {
          label : 'MASTER',
          field : 'master_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'C/MATE',
          field : 'c_mate_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : '2/MATE',
          field : 'second_mate_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'ADD 2/MATE',
          field : 'add_second_mate_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : '3/MATE',
          field : 'third_mate_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'C/ENGR',
          field : 'chief_engineer_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : '1A/E',
          field : 'first_assistant_engineer_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : '2A/E',
          field : 'second_assistant_engineer_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : '3A/E',
          field : 'third_assistant_engineer_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'BOSUN',
          field : 'bosun_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'A/B',
          field : 'able_bodied_seaman_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'O/S',
          field : 'ordinary_seaman_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : '#1OLR',
          field : 'no_1_oiler_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'OLR',
          field : 'oiler_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'WPR',
          field : 'wiper_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'C/COOK',
          field : 'chief_cook_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : '2/COOK',
          field : 'second_cook_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'M/MAN',
          field : 'messman_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        },
        {
          label : 'TOTAL',
          field : 'total_count',
          thClass : 'data-table-header text-center',
          tdClass: 'text-center',
          type: "number",
        }
      ];
    },

  },
  beforeMount(){
    this.getManningCrewFromCms()
  },
  watch:{
    // Reset sorting for tabs listed in tabList when the active tab changes
    crewSummaryModule(activeTab){
      const tabList = [
        'per_manning_assignment',
        'per_vessel',
      ]

      if(tabList.includes(activeTab)){
        this.sort = {
          field: null,
          order: null
        }
      }

      this.changeCardRankTitle('Onboard')
    }
  }
}
</script>

<style scoped >
.nav-tabs .nav-link.active {
  color: #d3313c !important;
}

.nav-pills .nav-link.active {

  background-color: #d3313c !important;
  color: white !important;
}

#ModelNav {
  padding: 0;
  li > a {
    padding: .5rem 2rem;
    color: #435464;
    height: 100%;
    text-align: center;
  }

  li:hover a {
    border-bottom: 2px solid #d3313c;
    color: #d3313c;
  }
  .nav-link span {
    font-size: 14px;
  }
}

.router-link-active {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;
  font-weight: bold;

  * {
    color: #d3313c;
  }
}

.e-tbl thead tr th, .e-tbl tbody tr th.custom, .e-tbl tbody tr td{
  border: 1px solid #b1b1b1;
}

.table-scroll {
  max-height: 500px;
  overflow: auto;
  position: relative;
  width: 100%;
}

.crew-table thead th {
  position: sticky;
  top: 0;
  background: #e1e1e1;
  z-index: 40;
  border-top: 1px solid #bbbbbb;
  border-bottom: 1px solid #bbbbbb;

  box-shadow: inset 0 -1px 0 #bbbbbb, inset -1px 0 0 #bbbbbb, inset 1px 0 0 #bbbbbb, inset 0 1px 0 #bbbbbb;
}

.crew-table th.sticky-col,
.crew-table td.sticky-col {
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 50;
  min-width: 201px;

  border-right: 1px solid #bbbbbb;
  border-left: 1px solid #bbbbbb;
  box-shadow: inset -1px 0 0 #bbbbbb, inset 1px 0 0 #bbbbbb;
}

.crew-table th.sticky-col:nth-child(2),
.crew-table td.sticky-col:nth-child(2) {
  left: 200px;
  min-width: 201px;
  z-index: 50;
  box-shadow: inset -1px 0 0 #bbbbbb, inset 1px 0 0 #bbbbbb;
}

.crew-table th.sticky-col:nth-child(3),
.crew-table td.sticky-col:nth-child(3) {
  left: 400px;
  min-width: 201px;
  z-index: 50;
  box-shadow: inset -2px 0 0 #000, inset 1px 0 0 #bbbbbb;
}

.crew-table thead th.sticky-col {
  z-index: 60 !important;
}

.crew-table thead th.sticky-header-background {
  background: #e1e1e1;
}

.sort-icons {
  display: inline-flex;
  flex-direction: column;
  margin-left: 5px;
  cursor: pointer;
  vertical-align: middle;
}

.arrow {
  width: 0;
  height: 0;
  margin: 1px 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  opacity: 0.4;
}

.arrow.up {
  border-bottom: 7px solid #1a1a1a;
}

.arrow.down {
  border-top: 7px solid #1a1a1a;
}

.arrow.active {
  border-bottom-color:#4c9ee8 !important;
  border-top-color: #4c9ee8 !important;
  opacity: 1;
}

.fixed-cell {
  width: 600px;
  min-width: 600px;
  max-width: 600px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
}

.table-no-border {
  border: none;
}

.table-no-border th,
.table-no-border td {
  border: none;
  padding-top: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 5px;
}

</style>
